<!-- Desktop US-CHIP Header -->
 <section class="bg-U-S-CHIP">
<app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>

<div class=" header-wrapper d-none d-md-block normal-header pb-md-1" [class.show]="!isSticky">
      <app-header-promotion  [custom_ticker]="custom_ticker"></app-header-promotion>
    <div class="row row-xl-12 px-lg-2 align-items-center us-header" [ngClass]="{ 'justify-content-center justify-content-lg-start justify-content-xxl-center': isWishlist}">
        <div class="col-md-12 col-lg-2 text-center text-lg-start logo-tabs ps-lg-4 ps-xl-5">
            <app-header-logo *ngIf="showLogo"></app-header-logo>
        </div>
        <div class="col-md-12 col-lg-9">
            <div class="row mt-lg-3">
                <div class="col-12 col-md-9 col-xl-9">
                    <div class="d-flex align-items-center justify-content-center justify-content-md-start justify-content-lg-center pb-md-2">
                        <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
                         <app-header-contact-us-section></app-header-contact-us-section>
                    </div>
                </div>
                 <div class="col-12 col-md-3 col-xl-3" *ngIf="chTheme4">
                    <div class="logo-stillen pb-3">
                        <img src="assets/images/uschiptuning/member.webp" class="img-fluid" alt="stillen-logo">
                    </div>
                 </div>
            </div>
            <div class="row justify-content-center align-items-center">
                <div class="col-12 col-md-7 col-lg-8 col-mid">
                    <app-header-search></app-header-search>
                </div>
                <div class="col-4 col-md-5 col-lg-4 cus-end">
                    <div class="d-flex justify-content-start hub-custom">
                        <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                        <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                    </div>
                </div>
            <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-start my-3 engine-col-custom">
         <app-header-third-row></app-header-third-row>
        </div>
            </div>
        </div>
    </div>
</div>

<!-- Sticky Header -->
<div class="sticky-header d-none d-md-block bg-black" [class.show]="isSticky">
    <div class="sticky-menu" [ngClass]="{ 'sticky-active': isSticky }">
        <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
    </div>
    <div class="header-wrapper py-2">
        <div class="row px-3 align-items-center us-header" [ngClass]="{ 'justify-content-center justify-content-lg-start justify-content-xxl-center': isWishlist}">
            <div class="col-md-12 col-lg-2 text-center text-lg-center logo-tabs  ps-5 d-flex justify-content-center dte-logo-sticky">
                <img  [routerLink]="'/'" (click)="onButtonClick()" *ngIf="showLogo"
                    [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo" alt="Logo"
                    class="img-fluid d-none d-md-block desktop-img cursor-pointer" fetchpriority="high" width="200"
                    height="70" />
            </div>
            <div class="col-md-12 col-lg-9">
                <div class="row align-items-center">
                    <div class="col-12 mt-1 col-md-7 col-lg-8  mt-3 custom-chip-left ">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-5 col-lg-4 mt-3 custom-chip-right ">
                        <div class="d-flex justify-content-start hub-custom p-0">
                             <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                            <app-header-cart-section *ngIf="showSecondRowHeader"
                                [showdowntooltip]="showdowntooltip"></app-header-cart-section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Header -->
<div class="container d-md-none">
    <app-header-mobile-menu [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"></app-header-mobile-menu>
</div>
<app-shopping-cart *ngIf="showCart"></app-shopping-cart>

</section>